<template>
    <html>
    <body style="background: #fff" v-loading="loading">
        <!--主体开始-->
        <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/purchase/list">供求广场</a>&gt; <a href="">供应详情</a>
            </div>
        </div>
        <section class="ncontainer2">
            <div class="neit">
                <h2>供应详情</h2>
                <div class="li1">
                    <h4>供应品类：{{model.categoryname}}{{!$util.isEmpty(model.attr_value_name) ? '(' + model.attr_value_name + ')' : ''}}</h4>
                    <div>
                        <div class="tu" v-if="model.image" style="margin-top:8px">
                            <img :src="$util.img(model.image)" alt="">
                        </div>
                        <ul style="width:90%">
                            <li>价格：<span style="color:#d60000;font-family: Bahnschrift;font-size:18px">{{model.price}}</span> {{model.unit}}</li>
                            <li>所在地：{{ model.areaname }}</li>
                            <li>商品描述：{{model.remark}}</li>
                        </ul>
                    </div>
                </div>
                <div class="li2">
                    <h4>供应商信息</h4>
                    <div>
                        <div>
                            <div class="tu"> <img :src="$util.img(member.headimg)" alt=""> </div>
                            <div class="y">
                                <div style="display:flex;">
                                      <p>发布人：{{member.nickname}}</p>
                                <p style="margin:0 20px">发布时间：{{ $util.timeStampTurnTime(model.createtime, 'YYYY-MM-DD') }}</p>
                                <p>浏览数：{{model.click_count}}</p>



                                </div>
                              <p>联系电话：<span style="color:#39bf3e;font-family: Bahnschrift;font-size:20px">400-080-6898</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </body>
</html>
</template>

<style scoped>
    .tu{width: 100px;height: 100px;border-radius: 10px;overflow: hidden;margin-right: 12px;}
    .tu img{width: 100%;height: 100%;}
</style>

<script>
    import { supplyDetail } from '@/api/supply/supply';
    import '@/assets/styles/css/iconfont.css';

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                id: 0,
                model:{},
                member:{},
            };
        },
        created() {
            this.id = this.$route.query.id;
            this.getdetails();
        },

        methods: {
            getdetails() {
                supplyDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        this.member = res.data.member_info;
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                });
            },
        },

        mounted () {

        },

    }
</script>
